import cn from 'classnames';

import classes from './Caption.module.scss';
import { CaptionProps } from './Caption.props';

export const Caption = ({ size = 'l', className, children, ...props }: CaptionProps): JSX.Element => {
  return (
    <p {...props} className={cn(className, classes[size])}>
      {children}
    </p>
  );
};
